export default {
  MuiSvgIcon: {
    styleOverrides: {
      fontSizeMedium: {
        fontSize: '24px'
      },
      fontSizeSmall: {
        fontSize: '16px'
      }
    }
  }
};
